/**
 * Calculates the sort string based on the current sort key and a new sort key.
 * If the sort keys are the same, it returns the new sort key with the opposite direction.
 * If the sort keys are different, it returns the new sort key in ascending (ASC) direction.
 *
 * @param {string} options.currentSort - The current sort key.
 * @param {string} options.newSortKey - The new sort key.
 * @returns {string} The calculated sort string.
 */
const calculateSortStr = ({ currentSort, newSortKey }) => {
  const isAsc = currentSort === newSortKey;

  return isAsc ? `-${newSortKey}` : newSortKey;
};

export default calculateSortStr;
